/**
 * @Description: 耗材的纸带材质信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  PaperTextureDefModel,
  PaperTextureDefSearchModel,
  PaperTextureDefPageSearchModel,
  PaperTextureDefAddModel,
  PaperTextureDefUpdateModel,
  IdsModel
} from '@/model/product/PaperTextureDefModel'

const baseUrl = Route.product + '/paperTextureDef'

/**
 * 搜索分页数据
 */
export const pageSearchPaperTextureDef = (param: PaperTextureDefPageSearchModel) => {
  return https().request<RootObject<PageRespModel<PaperTextureDefModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchPaperTextureDef = (param: PaperTextureDefSearchModel) => {
  return https().request<RootObject<PaperTextureDefModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getPaperTextureDef = (id: number) => {
  return https().request<RootObject<PaperTextureDefModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addPaperTextureDef = (param: PaperTextureDefAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updatePaperTextureDef = (param: PaperTextureDefUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removePaperTextureDef = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemovePaperTextureDef = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
